import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKakaoComponent } from './simple-icons-kakao.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKakaoComponent ],
    exports:      [ SimpleIconsKakaoComponent ],
    bootstrap:    []
})
export class SimpleIconsKakaoModule {}
